import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip, Button, Spinner, Modal, ModalHeader, ModalBody } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import { Preview } from "../../../../../helpers/ui/FileInput";
import MinioClient from "../../../../../services/minioClient";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/presensiService";

import IndexBloc from "../Blocs/IndexBlock";
import apiResponse from "../../../../../services/apiResponse";

import ReactTimeAgo from "react-time-ago";
import moment from "moment";

const formatDateWithTime = (value) => {
  if (value && value !== "-") {
    let date = new Date(value);
    const day = date.toLocaleString("id-ID", { day: "2-digit" });
    const month = date.toLocaleString("id-ID", { month: "short" });
    const year = date.toLocaleString("id-ID", { year: "numeric" });
    const time = date.toLocaleTimeString("id-ID");

    return day + " " + month + " " + year + " " + time;
  } else {
    return value;
  }
};

class TablePltPlhComponent extends Component {
  indexBloc = new IndexBloc();
  _isMounted = false;
  minioClient = new MinioClient();
  userdata = JSON.parse(localStorage.getItem("userdata"));
  source;

  constructor(props) {
    super(props);
    this.state = {
      loadingTable: false,
      cancelDate: null,
      rows: [],
      filteredRows: [],
      searchQuery: "",
      statusFilter: "",
      is_verif: 0,
      pending_approval_cuti: 0,
      verification: null,
      runType: null,
      confirmInfo: "Apakah anda yakin akan melakukan verifikasi PLT/PLH?",
      employee_nip: null,
      modalPreview: false,
      previewUuid: null,
    };
  }

  getStatusText = (row) => {
    if (row && row.plt_plh_period_detail_type == 1) return "Plt";
    if (row && row.plt_plh_period_detail_type == 2) return "Plh";
    return "-";
  };

  handleSearchChange = (e) => {
    const value = e.target.value;
    this.setState({ searchQuery: value }, () => {
      this.filterRows();
    });
  };

  handleStatusChange = (e) => {
    const value = e.target.value;
    this.setState({ statusFilter: value }, () => {
      this.filterRows();
    });
  };

  filterRows = () => {
    const query = (this.state.searchQuery || "").trim().toLowerCase();
    const statusFilter = (this.state.statusFilter || "").trim();

    const filtered = (this.state.rows || []).filter((row) => {
      if (query) {
        const nip = String(row.plt_plh_period_detail_employee_nip || "").toLowerCase();
        const name = String(row.plt_plh_period_detail_employee_name || "").toLowerCase();
        if (!nip.includes(query) && !name.includes(query)) {
          return false;
        }
      }

      if (statusFilter) {
        const rowStatus = this.getStatusText(row);
        if (rowStatus !== statusFilter) {
          return false;
        }
      }

      return true;
    });

    this.setState({ filteredRows: filtered });
  };

  setTokenAPI = () => {
    if (this.source) {
      this.source.cancel();
    }
    this.source = cancelToken();
  };

  getListPltPlh = async () => {
    this.setState({ loadingTable: true });
    var additionalFilter = this.props.additionalFilter;
    this.indexBloc.fetchListPltPlh({ ...additionalFilter });
  };

  handleButtonGeneratePLTPLH() {
    this.indexBloc.setGenerate({
      tipe: 6, // PLT PLH
      year: this.props.additionalFilter.year,
      month: this.props.additionalFilter.month,
      generate_verification_by_nip: this.userdata?.employee_nip,
      generate_verification_by_fullname: this.userdata?.employee_full_name,
    });
  }

  handleButtonExportPLTPLH = () => {
    this.indexBloc.fetchExportPltPlh({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
    });
  };

  handleButtonExportPLTPLHTxt = () => {
    this.indexBloc.fetchExportPltPlhTxt({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = { confirm: false };
        break;
      case "confirm":
        forState = { loading: true, confirm: false };
        if (this.state.runType == 1) this.submitVerification();
        if (this.state.runType == 2) this.syncData();
        if (this.state.runType == 5) this.handleButtonGeneratePLTPLH();
        if (this.state.runType == 10) this.openVerification();
        break;
      case "success":
        forState = { success: false, redirect: true };
        break;
      case "failed":
        forState = { failed: false };
        break;
      default:
    }
    this.setState(forState);
  };

  submitVerification = async () => {
    await this.indexBloc.fetchVerification({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
      description: this.userdata?.employee_full_name,
      type: 6, // PLT PLH
    });
  };

  openVerification = async () => {
    await this.indexBloc.openVerification({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
      description: this.userdata?.employee_full_name,
      nip: this.userdata?.employee_nip,
      type: 6, // PLT PLH
    });
  };

  syncData = async () => {
    let additionalFilter = this.props.additionalFilter;
    await this.indexBloc.fetchSync({
      employee_nip: this.state.employee_nip,
      type: 'pltplh',
      ...additionalFilter,
    });
  };

  fixMinioUrl = (brokenUrl) => {
    let once = decodeURIComponent(brokenUrl);
    const idx = once.indexOf("https://", 8);
    if (idx !== -1) {
      once = once.substring(idx);
    }
    const q1 = once.indexOf("?");
    const q2 = once.indexOf("?", q1 + 1);
    if (q1 !== -1 && q2 !== -1) {
      once = once.substring(0, q2);
    }
    return once;
  };

  renderPaymentStatus = (startDate, endDate) => {
    let isPaid = false;
    if (startDate) {
      const start = moment(startDate);
      let effectiveEndDate;

      if (endDate) {
        effectiveEndDate = moment(endDate);
      } else {
        const filterMonth = this.props.additionalFilter?.month;
        const filterYear = this.props.additionalFilter?.year;
        if (filterMonth && filterYear) {
          effectiveEndDate = moment({ year: filterYear, month: filterMonth - 1 }).endOf('month');
        } else {
          effectiveEndDate = moment().endOf('day');
        }
      }

      const monthsDiff = effectiveEndDate.clone().add(1, 'days').diff(start, 'months', true);
      isPaid = monthsDiff >= 1;
    }

    return (
      <span
        className="d-inline-flex align-items-center px-2 py-1 rounded-pill fw-semibold"
        style={{
          backgroundColor: isPaid ? "#d1f7e0" : "#f8d7da",
          color: isPaid ? "#198754" : "#dc3545",
          border: `1px solid ${isPaid ? "#7adf9b" : "#f5a0a8"}`,
          fontSize: "0.8rem",
        }}
      >
        <i className={`uil ${isPaid ? "uil-check-circle" : "uil-times-circle"} `}></i>
        {/* {isPaid ? "Dibayar" : "Tidak Dibayar"} */}
      </span>
    );
  };

  componentDidMount() {
    this.indexBloc.listPltPlhChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({ loadingTable: false, rows: [], filteredRows: [] });
          break;
        case apiResponse.LOADING:
          this.setState({ loadingTable: true });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          const rows = response.result || [];
          this.setState(
            {
              rows,
              loadingTable: false,
            },
            () => {
              this.filterRows();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({ loadingTable: false });
          break;
        default:
          break;
      }
    });

    this.indexBloc.openverificationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ loading: false, success: true });
          this.props.handleCheckGenerateSuccess();
          break;
        case apiResponse.ERROR:
          this.setState({ loading: false, failed: true });
          break;
        default:
          break;
      }
    });

    this.indexBloc.exportPltPlhChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({ loading: true });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          if (link?.file_url?.url_encoded) {
            window.open(link.file_url.url_encoded, "_blank");
          } else {
            window.open(link.file_url, "_blank");
          }
          this.setState({ loading: false, success: true });
          setTimeout(() => this.setState({ success: false }), 1000);
          break;
        case apiResponse.ERROR:
          this.setState({ loading: false, failed: true });
          setTimeout(() => this.setState({ failed: false }), 1000);
          break;
        default:
          break;
      }
    });

    this.indexBloc.exportPltPlhTxtChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({ loading: true });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          this.setState({ loading: false, success: true });
          setTimeout(() => this.setState({ success: false }), 1000);
          break;
        case apiResponse.ERROR:
          this.setState({ loading: false, failed: true });
          setTimeout(() => this.setState({ failed: false }), 1000);
          break;
        default:
          break;
      }
    });
    this.indexBloc.listPltPlhChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({ loadingTable: false, rows: [] });
          break;
        case apiResponse.LOADING:
          this.setState({ loadingTable: true });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          const rows = response.result || [];
          this.setState({ rows, filteredRows: rows, loadingTable: false });
          break;
        case apiResponse.ERROR:
          this.setState({ loadingTable: false });
          break;
        default:
          break;
      }
    });

    this.indexBloc.openverificationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ loading: false, success: true });
          this.props.handleCheckGenerateSuccess();
          break;
        case apiResponse.ERROR:
          this.setState({ loading: false, failed: true });
          break;
        default:
          break;
      }
    });

    this.indexBloc.exportPltPlhChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({ loading: true });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          if (link?.file_url.url_encoded) {
            const fixedUrl = this.fixMinioUrl(link.file_url.url_encoded);
            window.open(fixedUrl, "_blank");
          } else {
            window.open(link.file_url, "_blank");
          }
          this.setState({ loading: false, success: true });
          setTimeout(() => this.setState({ success: false }), 1000);
          break;
        case apiResponse.ERROR:
          this.setState({ loading: false, failed: true });
          setTimeout(() => this.setState({ failed: false }), 1000);
          break;
        default:
          break;
      }
    });

    this.indexBloc.exportPltPlhTxtChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({ loading: true });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          this.setState({ loading: false, success: true });
          setTimeout(() => this.setState({ success: false }), 1000);
          break;
        case apiResponse.ERROR:
          this.setState({ loading: false, failed: true });
          setTimeout(() => this.setState({ failed: false }), 1000);
          break;
        default:
          break;
      }
    });

    this.indexBloc.setgenerateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({ loadingTable: false, rows: [] });
          break;
        case apiResponse.LOADING:
          this.setState({ loadingTable: true });
          break;
        case apiResponse.COMPLETED:
          this.setState({ loading: false, success: true, loadingTable: false });
          this.props.handleCheckGenerateSuccess();
          break;
        case apiResponse.ERROR:
          this.setState({ loadingTable: false });
          break;
        default:
          break;
      }
    });

    this.indexBloc.verificationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ loading: false, success: true });
          this.props.handleCheckGenerateSuccess();
          break;
        case apiResponse.ERROR:
          this.setState({ loading: false, failed: true });
          break;
        default:
          break;
      }
    });

    this.indexBloc.syncChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            { loading: false, success: true, loadingTable: true },
            () => {
              this.setTokenAPI();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({ loading: false, failed: true });
          break;
        default:
          break;
      }
    });
  }

  // FIXED: Mematikan semua channel secara bersih
  componentWillUnmount() {
    this.indexBloc.listPltPlhChannel?.unsubscribe();
    this.indexBloc.exportPltPlhChannel?.unsubscribe();
    this.indexBloc.exportPltPlhTxtChannel?.unsubscribe();
    this.indexBloc.openverificationChannel?.unsubscribe();
    this.indexBloc.setgenerateChannel?.unsubscribe();
    this.indexBloc.verificationChannel?.unsubscribe();
    this.indexBloc.syncChannel?.unsubscribe();
  }

  render() {
    const uniqueStatuses = Array.from(
      new Set(
        (this.state.rows || [])
          .map((row) => this.getStatusText(row))
          .filter((s) => s !== "")
      )
    ).sort();

    return (
      <>
        {/* BAGIAN STATUS VERIFIKASI (Banner) */}
        <div className="mb-4">
          {this.props.additionalFilter.verification_data_is_verif_plt === 0 ? (
            <div className="alert alert-danger d-flex align-items-center py-2 m-0 shadow-sm" style={{ fontSize: "0.85rem" }}>
              <i className="uil uil-info-circle fs-5 me-2"></i>
              <span>
                Status Verifikasi PLT/PLH Periode{" "}
                <strong>
                  {this.props.additionalFilter.month_name} {this.props.additionalFilter.year}
                </strong>{" "}
                : <strong>Belum Dilakukan Verifikasi</strong>
              </span>
            </div>
          ) : this.props.additionalFilter.verification_data_is_verif_plt === 1 ? (
            <div className="alert alert-success d-flex align-items-center py-2 m-0 shadow-sm" style={{ fontSize: "0.85rem" }}>
              <i className="uil uil-check-circle fs-5 me-2"></i>
              <span>
                Telah dilakukan Verifikasi PLT/PLH Periode{" "}
                <strong>
                  {this.props.additionalFilter.month_name} {this.props.additionalFilter.year}
                </strong>{" "}
                oleh <strong>{this.props.additionalFilter.verification_data_description_plt}</strong> pada {formatDateWithTime(this.props.additionalFilter.verification_data_created_date_plt)}
              </span>
            </div>
          ) : null}
        </div>

        {/* BAGIAN TOMBOL AKSI */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          {/* Tombol Kiri */}
          <div>
            <Button
              color="success"
              size="sm"
              className="me-2 shadow-sm"
              onClick={() => {
                this.setState({
                  confirm: true,
                  runType: 5,
                  confirmInfo: "Apakah anda yakin akan melakukan proses Generate Ulang?",
                });
              }}
              disabled={this.props.additionalFilter.is_generate_plt == 0}
            >
              <i className="uil-refresh me-1"></i>
              {this.props.additionalFilter.is_pay_plt == 1
                ? `PLT/PLH Periode ${this.props.additionalFilter.month_name} ${this.props.additionalFilter.year} telah dibayarkan`
                : this.props.additionalFilter.generate_verification_status_plt == 0
                  ? `Proses Generate PLT/PLH oleh: ${this.props.additionalFilter.generate_verification_by_fullname_plt} (${this.props.additionalFilter.generate_verification_start_date_plt})`
                  : this.props.additionalFilter.generate_verification_status_plt == 1
                    ? `Generate Ulang PLT/PLH (Last: ${this.props.additionalFilter.generate_verification_start_date_plt} oleh ${this.props.additionalFilter.generate_verification_by_fullname_plt})`
                    : `Generate Ulang PLT/PLH Periode ${this.props.additionalFilter.month_name} ${this.props.additionalFilter.year}`}
            </Button>
            <Button
              color="danger"
              outline
              size="sm"
              className="shadow-sm"
              onClick={() =>
                this.setState({
                  confirm: true,
                  runType: 10,
                  confirmInfo: "Apakah anda yakin akan membuka ulang hasil verifikasi PLT/PLH?",
                })
              }
              style={{
                display: this.props.additionalFilter.verification_data_is_verif_plt == 1 && ["198501292014031001", "198903092012121002", "199508012025212056"].includes(this.userdata?.employee_nip) ? "inline-block" : "none",
              }}
            >
              <i className="uil uil-lock-open-alt me-1"></i> Buka Verifikasi
            </Button>
          </div>

          {/* Tombol Kanan */}
          <div className="d-flex align-items-center">
            <Button
              color="warning"
              outline
              size="sm"
              className="me-2 shadow-sm border-warning text-dark"
              onClick={() => {
                this.handleButtonExportPLTPLH();
              }}
            >
              <i className="uil-file-download me-1"></i> Export Xls
            </Button>
            <Button
              color="primary"
              size="sm"
              className="shadow-sm fw-bold"
              onClick={() =>
                this.setState({
                  confirm: true,
                  runType: 1,
                  confirmInfo: "Apakah anda yakin akan melakukan verifikasi PLT/PLH?",
                })
              }
              disabled={this.props.additionalFilter.verification_data_is_verif_plt == 1}
            >
              <i className="uil uil-check-circle me-1"></i> Verifikasi PLT/PLH
            </Button>
          </div>
        </div>

        <div className="d-flex flex-wrap gap-2 mb-3 align-items-center">
          <div className="input-group me-2" style={{ maxWidth: "340px" }}>
            <span className="input-group-text">
              <i className="uil uil-search"></i>
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Pencarian Berdasarkan NIP dan Nama"
              value={this.state.searchQuery || ""}
              onChange={this.handleSearchChange}
            />
          </div>

          <div style={{ minWidth: "180px" }}>
            <select
              className="form-select form-control"
              value={this.state.statusFilter || ""}
              onChange={this.handleStatusChange}
            >
              <option value="">Semua Status</option>
              {uniqueStatuses.map((s, idx) => (
                <option key={idx} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>
        </div>

        <style>{`
          .sticky-header-table thead th {
            box-shadow: inset -1px 0 0 #c8cce1, inset 0 -1px 0 #b9bfd3 !important;
          }
        `}</style>
        <div className="table-responsive" style={{ maxHeight: "75vh", overflowX: "auto", overflowY: "auto" }}>
          <Table className="table table-striped table-bordered sticky-header-table" style={{ minWidth: "1200px" }}>
            <thead
              className="table-primary"
              style={{
                position: "sticky",
                top: 0,
                zIndex: 3,
                backgroundColor: "#e9ecef",
              }}
            >
              <tr>
                <th
                  className="text-center align-middle"
                  style={{
                    width: "50px",
                    minWidth: "50px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                    boxShadow: "inset -1px 0 0 #c8cce1, inset 0 -1px 0 #b9bfd3",
                    position: "sticky",
                    left: 0,
                    zIndex: 4,
                  }}
                >
                  No
                </th>
                <th
                  className="text-center align-middle"
                  style={{
                    width: "250px",
                    minWidth: "250px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                    boxShadow: "inset -1px 0 0 #c8cce1, inset 0 -1px 0 #b9bfd3",
                    position: "sticky",
                    left: "50px",
                    zIndex: 4,
                  }}
                >
                  NIP <br />
                  Nama
                </th>
                <th
                  className="text-center align-middle"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                >
                  Jabatan Definitif
                </th>
                <th
                  className="text-center align-middle"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                >
                  Jabatan Plt/Plh
                </th>
                <th
                  className="text-center align-middle"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                >
                  Grade Plt / Plh
                </th>
                <th
                  className="text-center align-middle"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                >
                  SK
                </th>
                <th
                  className="text-center align-middle"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                >
                  TMT Mulai
                </th>
                <th
                  className="text-center align-middle"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                >
                  TMT Akhir
                </th>
                <th
                  className="text-center align-middle"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                >
                  SKP
                </th>
                <th
                  className="text-center align-middle"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.loadingTable === false ? (
                (this.state.filteredRows || []).length > 0 ? (
                  (this.state.filteredRows || []).map((data, index) => {
                    return (
                      <tr id={"tr_plt_" + index} style={{ border: "1px solid #c8cce1" }} key={index}>
                        <td
                          className="text-center"
                          style={{
                            borderColor: "#c8cce1",
                            boxShadow: "inset -1px 0 0 #c8cce1",
                            position: "sticky",
                            left: 0,
                            backgroundColor: "#ffffff",
                            zIndex: 2,
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            borderColor: "#c8cce1",
                            boxShadow: "inset -1px 0 0 #c8cce1",
                            position: "sticky",
                            left: "50px",
                            backgroundColor: "#ffffff",
                            zIndex: 2,
                          }}
                        >
                          <b>{data.plt_plh_period_detail_employee_nip}</b> <br /> {data.plt_plh_period_detail_employee_name} <br />
                          <br />
                          <small>{data.plt_plh_period_detail_employee_categories_name_full}</small>
                        </td>

                        <td className="text-left">{data.plt_plh_period_detail_position_name}</td>
                        <td className="text-left">{data.plt_plh_period_detail_plt_plh_position_name}</td>
                        <td className="text-center">{data.plt_plh_period_detail_plt_plh_grade}</td>
                        <td className="text-left">
                          <b>
                            <span
                              style={{ color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
                              onClick={() => {
                                if (data.plt_plh_period_detail_decree_document_path) {
                                  this.minioClient.get(data.plt_plh_period_detail_decree_document_path, 60, {
                                    'response-content-disposition': 'inline',
                                    'response-content-type': 'application/pdf'
                                  }).then((url) => {
                                    if (url) {
                                      this.setState({
                                        modalPreview: true,
                                        previewPath: url
                                      });
                                    }
                                  });
                                }
                              }}
                            >
                              {data.plt_plh_period_detail_decree_number}
                            </span>
                          </b> <br />
                          {data.plt_plh_period_detail_decree_date ? moment(data.plt_plh_period_detail_decree_date).format("DD-MM-YYYY") : "-"}
                        </td>
                        <td className="text-left">{data.plt_plh_period_detail_start_date ? moment(data.plt_plh_period_detail_start_date).format("DD-MM-YYYY") : "-"}</td>
                        <td className="text-left">{data.plt_plh_period_detail_end_date ? moment(data.plt_plh_period_detail_end_date).format("DD-MM-YYYY") : "-"}</td>
                        <td className="text-center">
                          {data.plt_plh_period_detail_skp_text ? (
                            <span dangerouslySetInnerHTML={{ __html: data.plt_plh_period_detail_skp_text }} />
                          ) : (
                            <span className="text-danger">-</span>
                          )}
                        </td>
                        <td className="text-center">{this.getStatusText(data)}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr style={{ border: "1px solid #c8cce1" }}>
                    <td colSpan="10" className="text-center">
                      Tidak Ada Data
                    </td>
                  </tr>
                )
              ) : (
                <tr style={{ border: "1px solid #c8cce1" }}>
                  <td colSpan="10" className="text-center">
                    <Spinner className="m-2" color="primary" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <ConfirmAlert
            confirmTitle="Konfirmasi!"
            confirmInfo={this.state.confirmInfo}
            loadingTitle="Mengambil data"
            loadingInfo="Tunggu beberapa saat"
            successTitle="Berhasil!"
            successInfo="Data berhasil diproses"
            failedTitle="Gagal!"
            failedInfo="Data gagal diproses"
            showConfirm={this.state.confirm}
            showLoading={this.state.loading}
            showSuccess={this.state.success}
            showFailed={this.state.failed}
            response={this.confirmResponse}
          />
          
          <Modal isOpen={this.state.modalPreview} toggle={() => this.setState({ modalPreview: false })} size="lg">
            <ModalHeader toggle={() => this.setState({ modalPreview: false })}>Preview Dokumen SK</ModalHeader>
            <ModalBody>
              {this.state.previewPath ? (
                <iframe
                  src={this.state.previewPath}
                  width="100%"
                  height="600px"
                  style={{ border: 'none' }}
                  title="Preview SK"
                />
              ) : (
                <div className="text-center py-4">Dokumen tidak ditemukan</div>
              )}
            </ModalBody>
          </Modal>
        </div>
      </>
    );
  }
}

export default TablePltPlhComponent;